import React from "react";
import { Grid, Checkbox, FormControlLabel, Box, Typography } from "@mui/material";
import { date_availability_fields, discountGroupObjects } from "../data";
import RenderInputField from "components/MboPaymentWorking/CommonComponents/RenderInputFiled/RenderInputFiled";

const weekDays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

function ApplicableDate({ value, setValue, disable }) {
	const applicableDays = value.applicable_date.applicable_days || [];
	const allDaysSelected = weekDays.every((day) => applicableDays.includes(day));
	const someDaysSelected = applicableDays.length > 0 && !allDaysSelected;

	const handleSelectAllDays = () => {
		setValue((prev) => ({
			...prev,
			applicable_date: {
				...prev.applicable_date,
				applicable_days: allDaysSelected ? [] : weekDays,
			},
		}));
	};

	const handleDayChange = (day) => {
		setValue((prev) => {
			const currentDays = prev.applicable_date.applicable_days || [];
			const updatedDays = currentDays.includes(day)
				? currentDays.filter((d) => d !== day)
				: [...currentDays, day];

			return {
				...prev,
				applicable_date: {
					...prev.applicable_date,
					applicable_days: updatedDays,
				},
			};
		});
	};

	return (
		<Box pl={2} display={"flex"} flexDirection={"row"} width={"100%"}>
			<Box display="flex" columnGap={2} flexDirection={"column"} rowGap="10px" flexWrap="wrap" width={"55%"}>
				{date_availability_fields?.map((row) => {
					return (
						<RenderInputField
							column={row}
							data={value}
							setData={setValue}
							width="100%"
							selectOptObjName={"option_data"}
							key={row.key}
							disabled={disable}
							minDateTime={value[discountGroupObjects.applicable_date.key].start_date}
						/>
					);
				})}
			</Box>
			{/* Applicable Days */}
			<Grid item xs={12} pl={10}>
				<Typography variant="body1" pb={1} pt={0}>
					Applicable Days
				</Typography>
				<Grid container spacing={0} display={"flex"} flexDirection={"column"}>
					<Grid item xs={3}>
						<FormControlLabel
							control={
								<Checkbox
									checked={allDaysSelected}
									indeterminate={someDaysSelected}
									disabled={disable}
									onChange={handleSelectAllDays}
								/>
							}
							label="Select All"
						/>
					</Grid>
					{weekDays.map((day) => (
						<Grid item xs={3} key={day}>
							<FormControlLabel
								control={
									<Checkbox
										checked={applicableDays.includes(day)}
										disabled={disable}
										onChange={() => handleDayChange(day)}
									/>
								}
								label={day}
							/>
						</Grid>
					))}
				</Grid>
			</Grid>
		</Box>
	);
}

export default ApplicableDate;
